export default __webpack_public_path__ + "static/media/openIconHeader.2003f5b4.svg";